import { getSrc } from "gatsby-plugin-image";
import { HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID, HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID, HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID, HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID, HOTEL_TAXONOMY_VERANDA_TAMARIN_ID } from "../constants";

const trimSentence = (sentence, limit) => {
  if (sentence.match(/(<([^>]+)>)/gi)) {
    sentence = sentence.replace(/(<([^>]+)>)/gi, "")
  }
  return sentence.length >= limit
    ? sentence
        .substr(0, limit - 3)
        .substring(0, sentence.substr(0, limit - 3).lastIndexOf(" ")) + "..."
    : sentence
}

const getHotelBookingCode = (hotelId) => {
  switch (hotelId) {
    case HOTEL_TAXONOMY_VERANDA_GRAND_BAIE_ID:
      return "74760"
    case HOTEL_TAXONOMY_VERANDA_PALMAR_BEACH_ID:
      return "74762"
    case HOTEL_TAXONOMY_VERANDA_PAUL_VIRGINIE_ID:
      return "74756"
    case HOTEL_TAXONOMY_VERANDA_POINTE_AUX_BICHES_ID:
      return "74764"
    case HOTEL_TAXONOMY_VERANDA_TAMARIN_ID:
      return "106630"
    default:
      return "verandaResorts"
  }
}

const getBreadcrumbs = () => {
  const crumbsHome = { pathname: "/", crumbLabel: "Home" }
  const crumbsArray = []

  const upTo = (el, tagName) => {
    tagName = tagName.toLowerCase()

    while (el && el.parentNode) {
      el = el.parentNode
      if (el.tagName && el.tagName.toLowerCase() === tagName) {
        return el
      }
    }

    return null
  }

  const currentLocation = window.location.pathname.endsWith("/")
    ? window.location.pathname.slice(0, -1)
    : window.location.pathname
  const currentPage = document.querySelector(
    "nav [href='" + currentLocation + "']"
  )

  if (currentPage !== null) {
    const currentPageName = currentPage.textContent
    const currentPageLink = currentPage.pathname

    crumbsArray.push({
      pathname: currentPageLink,
      crumbLabel: currentPageName,
    })

    let parentUl = upTo(currentPage, "ul")

    while (parentUl !== null && parentUl.id !== "") {
      let parentUlName = document.querySelector(
        "[data-submenu='" + parentUl.id + "']"
      ).textContent
      let parentUlLinkEl = document
        .querySelector("[data-submenu='" + parentUl.id + "']")
        .querySelector("a")
      let parentUlLink = parentUlLinkEl.pathname

      let isFirstLevelMenu = document
        .querySelector("[data-submenu='" + parentUl.id + "']")
        .parentElement.classList.contains("menu-main")
      let firstChildLink =
        isFirstLevelMenu && parentUlName.toLowerCase() !== "our presence"
          ? document.querySelector("#" + parentUl.id + " li a").pathname
          : "#"

      crumbsArray.unshift({
        pathname: parentUlLink !== "/" ? parentUlLink : firstChildLink,
        crumbLabel: parentUlName,
      })

      parentUl = upTo(parentUlLinkEl, "ul")
    }
  }
  crumbsArray.unshift(crumbsHome)
  return crumbsArray
}

const getCarouselImageOG = carousel => {
  let ogImage

  if (carousel.length > 0) {
    if (
      carousel[0].relationships.media.internal.type === "media__wistia" &&
        getSrc(carousel[0].relationships.media.relationships.thumbnail.gatsbyImage)
    ) {
      ogImage =
        getSrc(carousel[0].relationships.media.relationships.thumbnail.gatsbyImage)
    } else if (carousel[0].relationships.media.relationships.field_image) {
      ogImage =
        getSrc(carousel[0].relationships.media.relationships.field_image.gatsbyImage)
    }
  }
  return ogImage
}

const getExperienceArticleUrl = title => {
  return "/experience/" + title.replace(/\s+/g, "-").toLowerCase()
}

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  }
}

const getWebformURL = locale => {
  if (locale === "en") {
    return (
      process.env.GATSBY_API_URL +
      locale +
      "/api/veranda_resorts_webform_submissions/veranda_resorts_webform_submissions?_format=json"
    )
  }

  return (
    process.env.GATSBY_API_URL +
    "api/veranda_resorts_webform_submissions/veranda_resorts_webform_submissions?_format=json"
  )
}

// Sort by field weight
const sortByFieldWeight = data => {
  return data.sort(
    (a, b) =>
      (a.field_weight != null ? a.field_weight : Infinity) -
      (b.field_weight != null ? b.field_weight : Infinity)
  )
}

const formatBytes = (x) =>{

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  let l = 0, n = parseInt(x, 10) || 0;

  while(n >= 1024 && ++l){
      n = n/1024;
  }
  
  return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}

export {
  trimSentence,
  getBreadcrumbs,
  getCarouselImageOG,
  getExperienceArticleUrl,
  debounce,
  getWebformURL,
  sortByFieldWeight,
  getHotelBookingCode,
  formatBytes
}
